import * as React from "react";
import moment from "moment";

const VersionList: React.FunctionComponent<{
  versions?: any[];
  onView?: (docId: string) => void;
  isLandlordCopy?: boolean;
  hideClient?: boolean;
  hideVendor?: boolean;
}> = (props) => {


  const getStatus = (proposalDocument: any) => {
    const document = props?.isLandlordCopy
      ? proposalDocument?.seperateDocumentForLandlord
      : proposalDocument?.document;
    if (document?.internalApproval?.status === "Approved") {
      return "Internally Approved";
    }
    if (document?.internalApproval?.status === "Rejected") {
      return (
        <div>
          <div>Internally Rejected</div>
          {document?.internalApproval?.rejectedReason && (
            <div className="py-1 font-xs text-gray-800">
              <span className="text-gray-500">Reason:</span>{" "}
              {document?.internalApproval?.rejectedReason || ""}
            </div>
          )}
          {document.internalApproval?.comment && (
            <div className="py-1 font-xs text-gray-800">
              <span className="text-gray-500">Comments:</span>{" "}
              {document?.internalApproval?.comment || ""}
            </div>
          )}
        </div>
      );
    }
    if (document?.internalApproval?.status === "Pending") {
      return "Internal Approval Pending";
    }
    return "Draft";
  };
  return !!props.versions?.length ? (
    <>
      <div className="">
        <div className="table-responsive bg-white">
          <table className="table table-bordered w-100">
            <tr>
              <th className="font-sm font-weight-semibold">Version</th>
              <th className="font-sm font-weight-semibold">Created By</th>
              <th className="font-sm font-weight-semibold">Created Date</th>
              {!props.hideClient && (
                <th className="font-sm font-weight-semibold">
                  Client Acceptance & Agreed By
                </th>
              )}
              {!props.hideVendor && (
                <th className="font-sm font-weight-semibold">
                  Vendor/ Owner Acceptance & Agreed By
                </th>
              )}
              <th className="font-sm font-weight-semibold">Added Units</th>
              <th className="font-sm font-weight-semibold">Status</th>
            </tr>
            {props?.versions?.map((version) => {
              const document = props?.isLandlordCopy
                ? version?.seperateDocumentForLandlord
                : version?.document;

              return (
                <tr
                  onClick={() => props.onView?.(version?._id)}
                  className="cursor-pointer"
                >
                  <td className="font-sm font-weight-semibold">
                    V{version.versionNumber || document?.versionNumber}
                  </td>
                  <td className="font-sm font-weight-semibold">
                    <div className="d-flex align-items-center">
                      {version.createdBy?.name}
                    </div>
                  </td>
                  <td className="font-sm font-weight-semibold">
                    {moment(version?.createdAt).format("DD MMM YYYY hh:mm A")}{" "}
                  </td>
                  {!props.hideClient && (
                    <td className="font-sm font-weight-semibold">
                      {document?.clientApproval?.signedBy && (
                        <>
                          <div className="d-flex align-items-center">
                            Agreed by{" "}
                            {document?.clientApproval?.signedBy?.fullName}
                          </div>
                          <div>
                            <span className="text-gray-600">On</span>{" "}
                            {moment(document?.clientApproval?.signedAt).format(
                              "DD MMM YYYY hh:mm A"
                            )}{" "}
                          </div>
                        </>
                      )}
                    </td>
                  )}
                  {!props.hideVendor && (
                    <td className="font-sm font-weight-semibold">
                      {document?.landlordApproval?.signedBy && (
                        <>
                          <div className="d-flex align-items-center">
                            Agreed by{" "}
                            {document?.landlordApproval?.signedBy?.fullName}
                          </div>
                          <div>
                            <span className="text-gray-600">On</span>{" "}
                            {moment(
                              document?.landlordApproval?.signedAt
                            ).format("DD MMM YYYY hh:mm A")}{" "}
                          </div>
                        </>
                      )}
                    </td>
                  )}
                  <td className="py-2 border-bottom">
                    <div className="py-1">
                      {version?.proposedPropertyDetails.map((item: any)=><div className="mb-1 font-xs text-gray-600 border rounded-pill d-inline-flex py-1 px-2 align-items-center mr-2">
                        Floor:{" "}
                        {
                          item?.propertyDetails
                            ?.propertyDetailsFromProject?.floor
                        }{" "}
                        / Unit:{" "}
                        {
                          item?.propertyDetails
                            ?.propertyDetailsFromProject?.unitName
                        }{" "}
                        / Area:{" "}
                        {
                          item?.propertyDetails
                            ?.propertyDetailsFromProject?.area
                        }
                      </div>)}
                    </div>
                  </td>
                  <td className="font-sm font-weight-semibold">
                    {!document?.clientApproval &&
                    !document?.landlordApproval ? (
                      <>{getStatus(version)}</>
                    ) : (
                      <>
                        {!!document?.clientApproval && (
                          <>
                            {document?.clientApproval.status === "Pending"
                              ? "Sent to Client"
                              : "Client Approved"}
                          </>
                        )}
                        {!!document?.clientApproval &&
                          !!document?.landlordApproval && <>{", "}</>}

                        {!!document?.landlordApproval && (
                          <>
                            {document?.landlordApproval.status === "Pending"
                              ? "Sent to Owner"
                              : "Vendor/Owner Approved"}
                          </>
                        )}
                      </>
                    )}
                  </td>
                </tr>
              );
            })}
          </table>
        </div>
      </div>
    </>
  ) : (
    <></>
  );
};

export default VersionList;
